import azAuth from '@azinformatica/loki/src/utils/AzHasPermissions'
import { permissoes } from '@/core/constants'

export default {
	data() {
		return {
			permissoes: permissoes,
		}
	},
	methods: {
		montarPermissoes(...permissoes) {
			return permissoes.join(',')
		},
		verificarPermissao(...permissoes) {
			return azAuth(this.$store.state.loki.user.authorities, permissoes)
		},
	},
}
